import styled from "styled-components";
import { Button } from "../button";
export const StyledIconWrapper = styled.div ``;
export const TimePickerWrapper = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  button {
    top: 0;
  }
`;
export const UppercaseButton = styled(Button) `
  text-transform: uppercase;
`;
export const StyledWrapper = styled.div `
  position: absolute;
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.white};
  top: 100%;
  left: 0;
  box-shadow: 0 2px 6px rgba(182, 135, 135, 0.26);
  display: flex;
  flex-direction: column;
  .focus-area-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    height: 2.5rem;
    top: 5.5rem;
    display: flex;
    flex-direction: row;
    .focus-area {
      flex: 1;
      max-width: 3.5rem;
      margin-right: 1px;
      background-color: ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0.16);`} 
      :active {
        background-color: tranparent;
      }
    }
  }
  hr {
    margin: 0;
  }
`;
export const TimeChipsWrapper = styled.div `
  display: flex;
  flex-direction: row;
  height: 13.5rem;
  max-height: 13.5rem;
  > div {
    scroll-snap-type: y;
    margin: 0.5rem 0;
    min-width: 3.5rem;
    overflow-y: scroll;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }

    button {
      width: 100%;
      border: none;
      margin: 0;
      scroll-snap-align: start;
    }

  > hr {
    height: unset;
    margin:0;
  }
`;
export const ButtonsWrapper = styled.div `
  padding: 0.5rem 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 0;

  button {
    margin: 0;
  }
`;
